import BackendService from './BackendService';

export default class FeedService {
  static getFeeds() {
    return BackendService.get('/feeds/');
  }

  static getFeed(feedId) {
    return BackendService.get(`/feeds/${feedId}`);
  }

  static createFeed(feed) {
    return BackendService.post('/feeds/', { body: feed });
  }

  static updateFeed(feed) {
    return BackendService.put(`/feeds/${feed.id}`, { body: feed });
  }

  static deleteFeed(feedId) {
    return BackendService.delete(`/feeds/${feedId}`);
  }
}
